
  <div class="tabs-container" *ngIf="loggedInUserRole != 'HR Admin'">
    <ion-row *ngIf="!router.url.includes('Setup')  " >
      <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
        <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
          <mat-tab-group #tabGroup class="pt-10 pr-10"
          (selectedTabChange)="tabTypeChanged($event)">
        
            <mat-tab label="Employee"
            *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  person
                </span>My Report</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Manager"
          *ngIf=" (isFinanceLoginUser || loggedInUserRole == 'Manager') && !(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' ||loggedInUserRole=='Employee'  || approveMatrixValueForCondition=='EMPLOYEE_TO_FINANCE')" >
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>Team Report </span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Finance"
            *ngIf=" (isFinanceLoginUser || loggedInUserRole == 'HR Admin')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>Finance Report </span>
            </ng-template>
          </mat-tab>
          </mat-tab-group>
        </div>
      </ion-col>
    </ion-row>
    <div class="card">
    </div>
  </div>
<div class="container">
  <ion-row>
    <ion-col size="2" class="mt-10">
      <div class="formLabelRegularfs16 mb-5">
        Year
      </div>
      <mat-form-field class="w-100 mat-height40 mat-input-style">
        <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency" (selectionChange)="viewReimbursementReportByYear($event.value)">
          <mat-option [value]="item.year" *ngFor="let item of pmsYears">
            {{sharedService.transformYearToFyFormat(item.year)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ion-col>
 

      <ion-col size="2" class="mt-10" *ngIf="loggedInUserRole == 'HR Admin'">
        <div class="font_semibold fs-16 mb-5 ">
          Select Finance
        </div>
        <mat-form-field appearance="outline" class="w-100 mat-height40">
          <mat-select
            class="centered-label"
            name="reimbursementSelect"
            [(ngModel)]="financeIdForEmployee"
            (selectionChange)="getFinaceForReimbursement($event.value)">
            <mat-option [value]="-1">Select All Finance</mat-option>
            <mat-option *ngFor="let item of fitergetAllFinanceUserDD" [value]="item.id">
              {{ item.firstName }} {{ item.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
   
      <ion-col size="2" class="mt-10" *ngIf="(selectedTypeTabName=='Finance'||loggedInUserRole == 'HR Admin') && isShowSelectEmployee">
        <div class="font_semibold fs-16 mb-5 ">
          Select  Employee
        </div>
 
        <mat-form-field appearance="outline" class="w-100 mat-height40"> 
         
          <mat-select class="centered-label"   [(ngModel)]="selectedEmployee" name="reimbursementSelect" 
            (selectionChange)="getEmployeeForReimbursementApprove($event.value)">
            <mat-option [value]="-1" >Select All Employee              
            </mat-option>
            <mat-option [value]="item.employeeId" *ngFor="let item of allListingEmployeeId">

              {{ item.employeeName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>

      <ion-col size="2" class="mt-10"  *ngIf="selectedTypeTabName=='Manager'">
        <div class="font_semibold fs-16 mb-5 ">
          Select Employee 
        </div>


        <mat-form-field appearance="outline" class="w-100 mat-height40">
          <!--  [ngClass]="isReimbursementInvalid(item) ? 'red-background' : 'green-background'" -->
          <mat-select class="centered-label" name="reimbursementSelect"  [value]="-1" 
            (selectionChange)="getEmployeeForReimbursement($event.value)">
            <mat-option [value]="-1" >Select All Employee              
            </mat-option>
            <mat-option [value]="item.employeeId" *ngFor="let item of allListingEmployeeIdForTeam">

              {{ item.employeeName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
      <ion-col size="2" class="mt-10" *ngIf="selectedTypeTabName=='Finance'||loggedInUserRole == 'HR Admin' ">
        <div class="font_semibold fs-16 mb-5 ">
          Select Band 
        </div>
       
        <mat-form-field appearance="outline" class="w-100 mat-height40">
          <!--  [ngClass]="isReimbursementInvalid(item) ? 'red-background' : 'green-background'" -->
          <mat-select class="centered-label" name="reimbursementSelect" [value]="-1"
            (selectionChange)="getBandForReimbursement($event.value)">
            <mat-option [value]="-1">Select All Band
            </mat-option>
            <mat-option [value]="item.band" *ngFor="let item of arrBandsForReimursement">
      
              {{ item.band }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
      <ion-col size="2" class="mt-10" *ngIf="selectedTypeTabName=='Finance'||loggedInUserRole == 'HR Admin' ">
        <div class="font_semibold fs-16 mb-5 ">
          Select Location 
        </div>
      
  
        <mat-form-field appearance="outline" class="w-100 mat-height40">
          <!--  [ngClass]="isReimbursementInvalid(item) ? 'red-background' : 'green-background'" -->
          <mat-select class="centered-label" name="reimbursementSelect" [value]="-1"
            (selectionChange)="getLocationForReimbursement($event.value)">
            <mat-option [value]="-1">Select All Location
            </mat-option>
            <mat-option [value]="item.location" *ngFor="let item of arrLocationForReimursement">
      
              {{ item.location }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
      <ion-col size="2" class="mt-10" *ngIf="selectedTypeTabName=='Finance'||loggedInUserRole == 'HR Admin' ">
        <div class="font_semibold fs-16 mb-5 ">
          Select Expense Type 
        </div>
      
      
        <mat-form-field appearance="outline" class="w-100 mat-height40">
          <!--  [ngClass]="isReimbursementInvalid(item) ? 'red-background' : 'green-background'" -->
          <mat-select class="centered-label" name="reimbursementSelect" [value]="-1"
            (selectionChange)="getExpensTypeForReimbursement($event.value)">
            <mat-option [value]="-1">Select All Expense Type
            </mat-option>
            <mat-option [value]="item.reimbursementid" *ngFor="let item of arrExpensTypeData">
      
              {{ item.reimbursementType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>

  </ion-row>
  
  <ion-row>


    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
      <mat-form-field class="mat-height40 mat-input-style" style="margin-left: 20px;">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="search" placeholder="Search" [(ngModel)]="searchTaskString"
          (input)="onSearchTask(searchTaskString)">
      </mat-form-field>
    </ion-col>

    <ion-col size-sm="9" size-md="9" size-lg="9" size-xs="9">
      <div class="d-flex justify-content-flex-end ">

        <div>
          <label>
            <ion-label class="fs-14 font_regular pr-10 black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" placeholder="Select" [(value)]="selectedPageSize" (selectionChange)="onPageSizeChange()">
                <mat-option [value]="1">1</mat-option>
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
          </label>
        </div>
        <mat-form-field class="w250 mat mat-height40 mat-input-style mr-15">
          <mat-date-range-input [rangePicker]="fromToDateDashboard">
            <input matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate"
              (dateChange)="onDateChangeDashboard(taskFromDate,taskToDate)">
            <input matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate"
              (dateChange)="onDateChangeDashboard(taskFromDate,taskToDate)">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="fromToDateDashboard"></mat-datepicker-toggle>
          <mat-date-range-picker #fromToDateDashboard></mat-date-range-picker>
        </mat-form-field>


        <div class="d-flex" style="margin-right: 15px; cursor:pointer;">
          <span class="ml-5 mr-5 icon-download fs-20 material-icons" (click)="downloadExcel()">download</span>
        </div>
      </div>
    </ion-col>
  </ion-row> 

  <!------------------------------------------------------- HR Login ------------------------------------------------>

  <div class="card  employeeTab">

    <div class="p-10"  *ngIf="selectedTypeTabName=='Finance' ||loggedInUserRole == 'HR Admin'">
     

      <div class="table-container">

        <table class="custom-table rounded-header">

          <thead>
            <tr>
             
              <th *ngFor="let item of taskColumnHeaderInfoForFinanse" class="fs-14 font_bold cl-black">
                <div class="p-5 verticle-center justify-content-space-between icon-style">
                  {{ item?.label }}
                  <!--  -->
                  <div class="d-flex flex-column ml-10">
                    <i (click)="onSortAssending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                    <i (click)="onSortDesending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of allTeamMemberReimbursementApprove; let rowId = index">
            
              <td>
                {{row.employeeName}}
              </td>
              <td>
                {{row.reimbursementType}}
              </td>
              <td>
                {{row.location}}
              </td>
              <td>
                {{row.band}}
              </td>
              <td>
                {{ row.date | date: 'dd-MM-yyyy' }}
              </td>
                <td>
                  {{ row.dateOfExpense | date: 'dd-MM-yyyy' }}
                </td>
              <td>
                {{row.reimbursementLimit || '-'}}
              </td>
              <td>
                {{row.actualAmount}}
              </td>
              <td>
               
                {{row.assignedAmount}}
              </td>
              <td>

                <div *ngIf="row.uploadDocument !=  null">

                  <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/yellowdownload.png"
                    (click)="viewDocument(row.uploadDocument)" matTooltip="{{row.uploadDocument}}">
                </div>
              </td>
              <td>
                {{ formatedataVariable(row.status) }}
              </td>
              <td>
                
                <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.employeeComment" maxlength="255" readonly
                  [ngModelOptions]="{standalone: true}"></textarea>
              </td>
              <td *ngIf="approveMatrixValueForCondition !='EMPLOYEE_TO_FINANCE'">
                
                <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.managerComment" maxlength="255" readonly
                  [ngModelOptions]="{standalone: true}"></textarea>
              </td>
              <td>
                <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.financeComment" maxlength="255" readonly
                  [ngModelOptions]="{standalone: true}"></textarea>
                
              </td>
              <td>
               
                {{row.approvedStatus}}

              </td>
           
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mt-10" style="font-weight: bold;">
        {{allTeamMemberReimbursementApprove.length}} entries
      </div>
    </div>
  </div>
  <!-- ---------------------------------------------------------Employee-------------------------------------------------------------------- -->

  <div class="card  employeeTab"*ngIf="selectedTypeTabName =='Employee' && loggedInUserRole != 'HR Admin'">

    <div class="card-body">
      <div>

        <div class="p-10">

          <div class="table-container">

            <table class="custom-table rounded-header">

              <thead>
                <tr>

                  <th *ngFor="let item of taskColumnHeaderInfo" class="fs-14 font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style">
                      {{ item?.label }}
                      <!--  -->
                      <div class="d-flex flex-column ml-10">
                        <i (click)="onSortAssending(item.sortingName)"
                          class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                        <i (click)="onSortDesending(item.sortingName)"
                          class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of tableDataDetails; let i = index">
                  <!-- <td>
                <mat-checkbox [(ngModel)]="row.isSelected"></mat-checkbox>
              </td> -->
                  <td>
                    {{row.reimbursementType}}
                  </td>
                  <td>
                    {{ row.date | date: 'dd-MM-yyyy' }}
                  </td>
                    <td>
                      {{ row.dateOfExpense | date: 'dd-MM-yyyy' }}
                    </td>
                  <td>
                    {{row.reimbursementLimit || '-'}}
                  </td>
                  <td>
                    {{row.actualAmount}}
                  </td>
                  <td>
                    {{row.assignedAmount}}
                  </td>
                  <td>
                    <div *ngIf="row.uploadDocument !=  null">

                      <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/yellowdownload.png"
                        (click)="viewDocument(row.uploadDocument)" matTooltip="{{row.uploadDocument}}">
                    </div>
                  </td>
                  <td>
                    {{ formatedataVariable(row.status) }}
                  </td>
                  <td>
                    
                    <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.employeeComment" maxlength="255" readonly
                      [ngModelOptions]="{standalone: true}"></textarea>
                  </td>
                
                  <td *ngIf="approveMatrixValueForCondition !='EMPLOYEE_TO_FINANCE'">
                    
                    <textarea  rows="2" cols="4" class="edittextarea" [(ngModel)]="row.managerComment" maxlength="255" readonly
                      [ngModelOptions]="{standalone: true}"></textarea>
                  </td>
                  <td>
                    
                    <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.financeComment" maxlength="255" readonly
                      [ngModelOptions]="{standalone: true}"></textarea>
                  </td>
                  <td>
                    {{ row.approvedStatus === 'REJECTED' ? row.approvedStatus : (row.approvedByManager ||
                    row.approvedStatus) }}
                  </td>


                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt-10" style="font-weight: bold;">
            {{tableDataDetails.length}} entries
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-------------------------------------------------------Manager Login ------------------------------------------------>
 
  <div class="card  employeeTab">

    <div class="p-10" *ngIf="selectedTypeTabName=='Manager'">
      
      <div class="table-container">

        <table class="custom-table rounded-header">

          <thead>
            <tr>

              <th *ngFor="let item of taskColumnHeaderInfoForManager " class="fs-14 font_bold cl-black">
                <div class="p-5 verticle-center justify-content-space-between icon-style">
                  {{ item?.label }}
                  <!--  -->
                  <div class="d-flex flex-column ml-10">
                    <i (click)="onSortAssending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                    <i (click)="onSortDesending(item.sortingName)"
                      class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of allTeamReimbursement; let rowId = index">
           
              <td>
                {{row.employeeName}}
              </td>
              <td>
                {{row.reimbursementType}}
              </td>
              <td>
                {{ row.date | date: 'dd-MM-yyyy' }}

              </td>
                <td>
                  {{ row.dateOfExpense | date: 'dd-MM-yyyy' }}
                </td>
              <td>
                {{row.reimbursementLimit || '-'}}
              </td>
              <td>
                {{row.actualAmount}}
              </td>
              <td>
                {{row.assignedAmount}}
              </td>
              <td>
                <div *ngIf="row.uploadDocument !=  null">

                  <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/yellowdownload.png"
                    (click)="viewDocument(row.uploadDocument)" matTooltip="{{row.uploadDocument}}">
                </div>
              </td>
              <td>
                {{ formatedataVariable(row.status) }}
              </td>
              <td>
                <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.employeeComment" maxlength="255" readonly
                  [ngModelOptions]="{standalone: true}"></textarea>
                
              </td>
              <td *ngIf="approveMatrixValueForCondition !='EMPLOYEE_TO_FINANCE'">
                  <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.managerComment" maxlength="255" readonly
                    [ngModelOptions]="{standalone: true}"></textarea>
                
              </td>
              <td>
                
                <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="row.financeComment" maxlength="255" readonly
                  [ngModelOptions]="{standalone: true}"></textarea>
              </td>
              <td>
                
                {{row.approvedByManager || 'PENDING'}}
              </td>

            </tr>
          </tbody>
        </table>


      </div>
      <div class="mt-10" style="font-weight: bold;">
        {{allTeamReimbursement.length}} entries
      </div>
    </div>
  </div>
</div>